import React, { useState } from 'react';
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';
import { Check, Close, Block } from '@mui/icons-material';
import { scoutService } from '../../services/scoutService';

interface Props {
  threadId: string;
  status: string;
  onActionDone: () => void;
}

const ScoutActionButtons: React.FC<Props> = ({ threadId, status, onActionDone }) => {
  const [confirmAction, setConfirmAction] = useState<'accepted' | 'declined' | 'blocked' | null>(null);
  const [processing, setProcessing] = useState(false);

  if (!status || ['accepted', 'declined', 'blocked'].includes(status)) {
    return null;
  }

  const handleAction = async () => {
    if (!confirmAction) return;
    setProcessing(true);
    try {
      await scoutService.action(threadId, confirmAction);
      onActionDone();
    } catch (err) {
      console.error('Action failed:', err);
    } finally {
      setProcessing(false);
      setConfirmAction(null);
    }
  };

  const labels = {
    accepted: { label: '承諾', desc: 'スカウトを承諾すると、企業に通知が送られます。個人情報は共有されませんのでご安心ください。', color: '#4caf50' },
    declined: { label: '辞退', desc: 'スカウトを辞退すると、企業に通知が送られます。個人情報は共有されませんのでご安心ください。', color: '#f44336' },
    blocked: { label: 'ブロック', desc: 'この企業をブロックすると、今後プロフィールが表示されなくなります。', color: '#666' },
  };

  return (
    <>
      <Box sx={{ display: 'flex', gap: 1.5 }}>
        <Button
          variant="contained"
          startIcon={<Check />}
          onClick={() => setConfirmAction('accepted')}
          sx={{ bgcolor: '#4caf50', '&:hover': { bgcolor: '#388e3c' } }}
        >
          承諾
        </Button>
        <Button
          variant="outlined"
          startIcon={<Close />}
          onClick={() => setConfirmAction('declined')}
          color="error"
        >
          辞退
        </Button>
        <Button
          variant="text"
          startIcon={<Block />}
          onClick={() => setConfirmAction('blocked')}
          sx={{ color: '#666' }}
        >
          ブロック
        </Button>
      </Box>

      <Dialog open={!!confirmAction} onClose={() => setConfirmAction(null)}>
        <DialogTitle>
          {confirmAction ? labels[confirmAction].label : ''}の確認
        </DialogTitle>
        <DialogContent>
          <Typography>{confirmAction ? labels[confirmAction].desc : ''}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmAction(null)}>キャンセル</Button>
          <Button
            variant="contained"
            onClick={handleAction}
            disabled={processing}
            sx={{ bgcolor: confirmAction ? labels[confirmAction].color : undefined }}
          >
            {processing ? '処理中...' : '確定'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ScoutActionButtons;
